// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BannerSpace_wrapper__pzStb"};